import { snakeStore } from '@/plugins/vuex-async-pagginate';
import { SipAccountService } from '@pbx/services/SipAccountService';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => SipAccountService.getList(params)
    }
  },
  true
);
